import { Component } from '@angular/core';
import { FrattaleService } from './services/frattale.service';
import { UtenteService } from './services/utente.service';
import { Utente } from './models/rbac/Utente';
import { CommonModule } from '@angular/common';
import { ActivatedRoute , RouterModule } from '@angular/router';
import { NavigationComponent } from './views/main-layout/navigation/navigation.component';
import { FooterComponent } from './views/main-layout/footer/footer.component';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [CommonModule, RouterModule, NavigationComponent,
    FooterComponent
  ],
  providers: [FrattaleService, UtenteService/* , ActivatedRoute */]
})
export class AppComponent {
  title = 'TradingFrattale';
  specialPage = false;
  utenteLoggato: Utente = new Utente()

  constructor(private utente: UtenteService) {
    let ut = this.utente.getUtente()
    if (ut.getTipoUt() == 'guest') {
      let u = window.sessionStorage.getItem('utente')
      if (u) {
        try{
          let loggato = JSON.parse(u)
          this.utente.setUtente(loggato)
          this.utenteLoggato.setUtente(loggato)
          this.utente.setIsLogin(this.utenteLoggato)
        }catch(e){
          console.log(e)
          window.localStorage.removeItem('utente')
        }        
      }
    }
  }

  goBack() { }
}
